import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import {
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Checkbox,
  FormControlLabel,
  IconButton,
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'

import EditIcon from '@material-ui/icons/Edit'

import {
  getEnsambladoras,
  postEnsambladora,
  putEnsambladora,
  deleteEnsambladora,
} from '@auteco/services/sostenibilidadService'

const UsuariosSostenibilidadContainer = () => {
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false)
  const [newCompany, setNewCompany] = useState('')
  const [editCompany, setEditCompany] = useState(null)
  const [isActive, setIsActive] = useState(true)
  const [loadingEnsambladoras, setLoadingEnsambladoras] = useState(false)

  const columns = [
    { title: 'Ensambladora', field: 'empresa' },
    { title: 'Activo', field: 'activo', type: 'boolean' },
    {
      title: 'Acciones',
      field: 'acciones',
      render: (rowData) => (
        <EditIcon
          style={{ cursor: 'pointer' }}
          onClick={() => handleEditOpen(rowData)}
        />
      ),
    },
    {
      title: 'Eliminar',
      field: 'eliminar',
      render: (rowData) => (
        <IconButton onClick={() => handleDeleteEnsambladora(rowData.id)}>
          <DeleteIcon />
        </IconButton>
      ),
    },
  ]

  const handleOpen = () => {
    setOpen(true)
    setEditCompany(null)
    setNewCompany('')
    setIsActive(true)
  }

  const handleEditOpen = (rowData) => {
    setOpen(true)
    setEditCompany(rowData)
    setNewCompany(rowData.empresa)
    setIsActive(rowData.activo)
  }

  const handleClose = () => {
    setOpen(false)
    setNewCompany('')
    setEditCompany(null)
    setIsActive(true)
  }

  const handleGetEnsambladoras = async () => {
    setLoadingEnsambladoras(true)
    const { ensambladoras } = await getEnsambladoras()
    if (ensambladoras) {
      const formattedData = ensambladoras.map((empresa) => ({
        id: empresa.id,
        empresa: empresa.nombre,
        activo: empresa.activo === '1',
      }))
      setData(formattedData)
    }
    setLoadingEnsambladoras(false)
  }


  const handleDeleteEnsambladora = async (id) => {
    const response = await deleteEnsambladora(id)
    if (response.data.success) {
      alert('Ensambladora eliminada correctamente')
    } else {
      alert('No se pudo eliminar la ensambladora')
    }
    await handleGetEnsambladoras()

  }


  const handleAdd = async () => {
    if (newCompany) {
      if (editCompany) {
        // Edit existing company
        await putEnsambladora({
          id: editCompany.id,
          nombre: newCompany,
          activo: isActive ? 1 : 0,
        })
        await handleGetEnsambladoras()
      } else {
        // Add new company
        await postEnsambladora({ nombre: newCompany })
      }
      await handleGetEnsambladoras()
      handleClose()
    }
  }

  useEffect(() => {
    handleGetEnsambladoras()
  }, [])

  return (
    <div>
      <MaterialTable
        title="Ensambladoras"
        columns={columns}
        loading={loadingEnsambladoras}
        data={data}
        options={{
          headerStyle: {
            backgroundColor: '#f1f1f1',
            color: 'black',
            fontWeight: 'bold',
          },
        }}
      />

      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        style={{ marginTop: '20px' }}
      >
        Agregar Ensambladora +
      </Button>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {editCompany ? 'Editar Ensambladora' : 'Nueva Ensambladora'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoFocus
                margin="dense"
                label="Nombre"
                type="text"
                fullWidth
                value={newCompany}
                onChange={(e) => setNewCompany(e.target.value)}
              />
            </Grid>
            {editCompany && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isActive}
                      onChange={(e) => setIsActive(e.target.checked)}
                      color="primary"
                    />
                  }
                  label="Activo"
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleAdd} color="primary" variant="contained">
            {editCompany ? 'Guardar cambios' : 'Guardar ensambladora'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default UsuariosSostenibilidadContainer
